import React from 'react';
import { usePersistedState } from './usePersistedState';

// FIXME Move to hooks folder
// FIXME Need to think about which of these should be linked to the user directly in the database - if they should, switch to useUserState((user) => user.param) or something
export const useStartScreen = () => usePersistedState('start-screen', 'Feed');
export const useNearbyFilters = (defaults) => usePersistedState('nearby-filters', defaults);
export const useHumidorSort = (defaults) => usePersistedState('humidor-sort', defaults); // Currently stored in ls as "selectedSort"
export const useAlertStatus = (defaults) => usePersistedState('alert-status', defaults);
